function initCampaignTicker() {
  var params = new URLSearchParams(window.location.search);

  function getCookie(name) {
    var match = document.cookie.match('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name) {
    document.cookie = name + '=1; max-age=2592000; path=/; SameSite=Lax';
  }

  document.querySelectorAll('[data-section-name="campaign-ticker"]').forEach(function (section) {
    var id = section.id;
    var storageKey = 'campaign-ticker:' + id;
    var utmValue = section.dataset.utmCampaign;
    var customName = section.dataset.customParamName;
    var customValue = section.dataset.customParamValue;

    var discountCode = section.dataset.discountCode;
    var show = false;
    var firstMatch = false;

    if (getCookie(storageKey)) {
      show = true;
    } else {
      if (utmValue && params.get('utm_campaign') === utmValue) show = true;
      if (!show && customName && customValue && params.get(customName) === customValue) show = true;
      if (show) {
        setCookie(storageKey);
        firstMatch = true;
      }
    }

    if (show && firstMatch && discountCode) {
      fetch('/discount/' + encodeURIComponent(discountCode));
    }

    if (show) {
      section.style.removeProperty('display');
      var ticker = section.querySelector('ticker-section');
      if (ticker && typeof ticker.resizeHandler === 'function') {
        ticker.resizeHandler();
      }
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCampaignTicker);
} else {
  initCampaignTicker();
}
